import { useSDUIFilterablePaginatedSectionFilters } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionFilters";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import { IGetSDUIFiltersRequest } from "@faire/web-api--source/indigofair/data/IGetSDUIFiltersRequest";

export const useSDUIFiltersRequest = (
  filterablePaginatedSection: IFilterablePaginatedSection
) => {
  const filterKeys = useSDUIFilterablePaginatedSectionFilters();
  const filteredComponentsRequest =
    filterablePaginatedSection.get_s_d_u_i_filtered_components;

  return IGetSDUIFiltersRequest.build({
    page_identifier: filteredComponentsRequest?.page_identifier,
    filter_keys: filterKeys,
  });
};
